<template>
  <div id="contents" class="coupon contents">
    <div class="productView" v-if="coupon">
      <div class="productItem">
        <products-image :imageList="[coupon.imageUrl]"></products-image>
        <!-- <span class="productSetting"></span> -->
        <div class="productWrap">
          <div class="productDeco">
            <button
              type="button"
              class="btSetting"
              @click="isSettingVisible = true"
            >
              <span class="icon iconSetting"></span>
              <span class="accessibilityHide">
                {{ $t('common.accessibility.settings') }}
              </span>
            </button>
            <span class="productName">{{ coupon.productName }}</span>
            <span class="productGame">{{ coupon.serviceName }}</span>
            <!-- <span class="productCate"><span class="cateNew">신규</span><span class="cateHot">인기</span></span> -->
          </div>
        </div>
        <span class="productPin">
          <template>
            <span class="numPin" v-if="isProductPin">
              {{ coupon.couponPin }}
            </span>
            <button
              type="button"
              class="button11 btPin"
              @click="checkPin"
              v-else
            >
              {{ $t('coupon.check_coupon_number') }}
              {{
                shopId === '30th' ? '' : `(${$t('coupon.confirm_purchase')})`
              }}
            </button>
          </template>
        </span>
        <span class="productPeriod">
          <span :class="`productState ${couponStatus.className}`">
            {{ couponStatus.result }}
          </span>
          {{ $t('coupon.validity_period') }} |
          {{ convertDate(coupon.expireDate) }} {{ $t('coupon.until') }}
          <strong v-if="isDeletable === false">({{ remainExpireDay }})</strong>
        </span>
      </div>
      <div class="productDetail ql-container ql-snow">
        <p class="ql-editor" v-html="coupon.couponDesc"></p>
      </div>
    </div>
    <setting v-show="isSettingVisible" @close="isSettingVisible = false">
      <ul slot="menu">
        <li v-if="shopId !== '30th'">
          <button type="button" @click="handleClick('cancel')">
            {{ $t('coupon.withdrawal') }}
          </button>
        </li>
        <li>
          <button type="button" @click="handleClick('delete')">
            {{ $t('coupon.delete') }}
          </button>
        </li>
      </ul>
    </setting>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import ProductsImage from '@/views/base/ProductsImage'
import Setting from '@/views/base/Setting'
import Modal from '@/views/base/Modal'
import MyAPI from '@/api/my'
import { mapActions, mapGetters } from 'vuex'
import { beforeSendLog } from '@/utils'

export default {
  name: 'CouponView',
  props: {
    couponId: {
      type: Number,
      default: -1
    }
  },
  components: {
    ProductsImage,
    Setting,
    Modal
  },
  data() {
    return {
      isSettingVisible: false,
      clipboard: null,
      coupon: {}
    }
  },
  computed: {
    ...mapGetters('main', ['shopId']),
    remainExpireDay() {
      let result = ''
      const { remainExpireDay } = this.coupon
      if (remainExpireDay >= 0) {
        if (remainExpireDay === 0) {
          result = this.$t('coupon.until_today')
        } else {
          result = `${remainExpireDay.addComma()}${this.$t(
            'coupon.days_remaining'
          )}`
        }
      }
      return result
    },
    isClipboardSupported() {
      return ClipboardJS.isSupported()
    },
    isProductPin() {
      return (
        this.coupon.hasOwnProperty('couponPin') &&
        this.coupon.couponPin !== null
      )
    },
    isExpired() {
      return this.coupon.couponPinStatus === 50
    },
    couponStatus() {
      let result = ''
      let className = ''
      if (this.coupon.couponPinStatus === 50) {
        result = this.$t('coupon.expired')
      } else if (this.coupon.couponPinStatus === 30) {
        result = this.$t('coupon.used')
      } else {
        if (this.coupon.purchaseProductCouponStatus === 100) {
          result = `${this.coupon.autoConfirmDate} ${this.$t(
            'coupon.automatic_purchase_confirmation'
          )}`
          className = 'productStateViolet'
        } else if (this.coupon.purchaseProductCouponStatus === 150) {
          result = this.$t('coupon.usable')
          className = 'productStateGray'
        }
        this.usable = true
      }
      return { result, className }
    },
    isDeletable() {
      return (
        this.isExpired ||
        (this.coupon.purchaseProductCouponStatus === 150 &&
          this.coupon.couponPinStatus === 30)
      )
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('my', ['getCouponUsableList', 'getCouponUnusableList']),
    callAPI() {
      MyAPI.getCouponDetail(this.couponId, responseData => {
        this.coupon = { ...this.coupon, ...responseData.data }
      })
    },
    checkPin() {
      if (
        this.coupon.couponPin === null &&
        this.coupon.purchaseProductCouponStatus === 100
      ) {
        this.openModal({
          type: 'confirm',
          message:
            this.shopId === '30th'
              ? this.$t('alert.confirm_coupon_number')
              : this.$t('alert.confirm_coupon_number_warning'),
          callback: () => {
            MyAPI.activeCoupon(this.couponId, responseData => {
              if (responseData.code === 0) {
                this.getCouponUsableList(true)
                beforeSendLog('Confirm')
                this.coupon.couponPin = responseData.data.pinNo
                this.coupon.purchaseProductCouponStatus = 150 // 구매확정 상태로 변경
              }
            })
          }
        })
      }
    },
    handleClick(type) {
      if (type === 'cancel') {
        // 청약 철회
        if (this.coupon.purchaseProductCouponStatus === 150 || this.isExpired) {
          // 이미 발행된 경우
          this.openModal({
            type: 'alert',
            message: this.$t('alert.unable_to_withdraw')
          })
        } else if (
          this.coupon.purchaseProductCouponStatus === 100 ||
          this.coupon.purchaseProductCouponStatus === 101
        ) {
          beforeSendLog('Refund')
          // 사용가능 인 경우
          this.$router.push({
            name: 'cancelApply',
            params: {
              coupon: this.coupon,
              couponId: this.coupon.purchaseProductId
            }
          })
        }
      } else {
        // 삭제
        if (this.isDeletable) {
          this.openModal({
            type: 'confirm',
            message: this.$t('alert.confirm_delete_coupon'),
            callback: () => {
              MyAPI.deleteCoupon(this.couponId, responseData => {
                if (responseData.code === 0) {
                  this.getCouponUnusableList(true)
                  beforeSendLog('Delete')

                  setTimeout(() => {
                    this.openModal({
                      type: 'alert',
                      message: this.$t('alert.coupon_deleted')
                    })
                  }, 500)
                  this.$router.go(-1)
                }
              })
            }
          })
        } else {
          this.openModal({
            type: 'alert',
            message: this.$t('alert.cannot_delete_unused_coupon')
          })
        }
      }
    },
    convertDate(date) {
      return date && date.replace('T', ' ')
    }
  },
  mounted() {
    this.callAPI()
    this.$nextTick(() => {
      if (this.isClipboardSupported) {
        this.clipboard = new ClipboardJS('.numPin', {
          text: () => this.coupon.couponPin
        })
        this.clipboard.on('success', e => {
          this.openModal({
            type: 'alert',
            message: this.$t('alert.coupon_number_copied')
          })
        })
        this.clipboard.on('error', e => {
          this.openModal({
            type: 'alert',
            message: this.$t('alert.coupon_copy_failed')
          })
        })
      }
    })
  },
  destroyed() {
    if (this.clipboard) this.clipboard.destroy()
  }
}
</script>

<style lang="scss">
.coupon {
  .productPin {
    display: block;
    padding: 26px 16px 16px;
    border-bottom: 1px solid #efefef;
    .btPin {
      height: 45px;
    }
    .numPin {
      display: block;
      width: 100%;
      height: 45px;
      padding-top: 15px;
      text-align: center;
      border: 1px solid #151721;
    }
  }
  .productView {
    span.productName {
      margin: 0 60px 14px 16px;
    }
    .productGame {
      font-size: 13px;
      font-weight: bold;
    }
    .productSetting {
      display: block;
      width: 100%;
      height: 10px;
      position: relative;
      margin-bottom: -10px;
    }
    .btSetting {
      position: absolute;
      top: 13px;
      right: 11px;
      width: 30px;
      height: 30px;
    }
    .productPeriod {
      display: block;
      height: 78px;
      padding: 16px 16px 0;
      margin: 0 0 -5px;
      font-size: 14px;
      border-top: 10px solid #f7f7f7;
      border-bottom: 1px solid #e9eaf1;
    }
    .productState {
      padding-bottom: 9px;
    }
    .productDetail {
      position: relative;
      margin-top: 5px;
    }
    .productDisable {
      opacity: 0.5;
    }
  }
}
</style>
